import { getLocation, routes } from "@src/appV2/redesign/utils/routes";
import { NavigationItem } from "./types";

export function isPathSelected(currentPath: string, routePathname: string): boolean {
  if (!currentPath.startsWith(routePathname)) {
    return false;
  }

  const nextChar = currentPath[routePathname.length];
  return nextChar === undefined || nextChar === "/" || nextChar === "?";
}

export function getRouteAndSelected(
  route: keyof typeof routes,
  currentPath: string
): Pick<NavigationItem, "routeTo" | "isSelected"> {
  const routeTo = getLocation(route);
  return {
    routeTo,
    isSelected: routeTo.pathname ? isPathSelected(currentPath, routeTo.pathname) : false,
  };
}
